// Osdorp-Midden geographic configuration
// Bounds derived from wijk_geojson_osdpm.json

// Base bounds [ [southLat, westLng], [northLat, eastLng] ]
const BASE_BOUNDS: [[number, number], [number, number]] = [
  [52.3462, 4.7866],
  [52.3645, 4.8037],
];

// Add buffer to allow panning outside the strict neighborhood
// Buffer: ~0.01 degrees ≈ 1.1 km in each direction
const BUFFER = 0.01;

// Expanded bounds with buffer for map panning
export const OSDORP_BOUNDS: [[number, number], [number, number]] = [
  [BASE_BOUNDS[0][0] - BUFFER, BASE_BOUNDS[0][1] - BUFFER],
  [BASE_BOUNDS[1][0] + BUFFER, BASE_BOUNDS[1][1] + BUFFER],
];

// Simple center point of the base bounds (not the buffered bounds)
export const OSDORP_CENTER: [number, number] = [
  (BASE_BOUNDS[0][0] + BASE_BOUNDS[1][0]) / 2,
  (BASE_BOUNDS[0][1] + BASE_BOUNDS[1][1]) / 2,
];

